<template>
  <el-checkbox
    :key="checked"
    :label="option.value"
    size="large"
    class="checkbox-option"
    :class="{ 'checkbox-option--truncate': truncate }"
    :checked="checked"
    @change="handleChange"
  >
    <span v-html="option.label"></span>
  </el-checkbox>
</template>

<script>
export default {
  name: 'CheckboxOption',
  props: {
    option: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    truncate: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleChange(isChecked) {
      this.$emit('change', isChecked);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/helpers/variables';
.checkbox-option {
  white-space: normal;

  &--truncate {
    white-space: nowrap;

    .el-checkbox {
      white-space: nowrap;
    }
    .el-checkbox__label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }

  &:hover {
    .el-checkbox__inner {
      background-color: $primary;
    }
  }

  .el-checkbox {
    // &__label {
    //   width: 100%;
    //   white-space: nowrap;
    //   overflow: hidden;
    //   text-overflow: ellipsis;
    // }
    &__inner {
      border-radius: 50%;
      border-color: $gray3;

      &::after {
        height: 5px;
        left: 4px;
        top: 2px;
      }
    }

    &__input.is-checked .el-checkbox__inner {
      background-color: $primary;
      border-color: $basicWhite;
    }

    &__input.is-checked + .el-checkbox__label {
      color: inherit;
    }
  }
}
</style>
